import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { BaseInputComponent } from '../base-input/base-input.component';

@Component({
  selector: 'app-toggle-input',
  templateUrl: './toggle-input.component.html',
  styleUrls: ['./toggle-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToggleInputComponent extends BaseInputComponent implements OnInit {
	@Input() color: string = 'primary';
	@Input() labelPosition: "before" | "after" = "after";

	constructor() {
		super();
	}

}
